<template>
	<div class="md-layout">
		<div class="md-layout-item md-medium-size-100 md-size-100">
			<h4>{{translate(locale.editJob)}}</h4>
		</div>
		<div class="md-layout-item md-medium-size-100 md-size-100" v-if="!loaded">
			<md-card>
				<md-card-content>
					<loading />
				</md-card-content>
			</md-card>
		</div>

		<div class="md-layout-item md-medium-size-100 md-size-100" v-if="loaded">
			<md-card>
				<md-card-content>
					<div class="md-layout">
						<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-70">
							<div class="md-layout">
								<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
									<h5>{{translate(locale.jobInformation)}}</h5>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-100 text-right">
									<span class="late">{{translate(locale.required)}}</span>
								</div>
								<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
									<form-input v-model="job.name" :label="locale.jobName"/>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-50">
									<form-select v-model="job.job_category_id" :list="job_category_list" :label="locale.jobCategory"/>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-50">
									<form-select v-model="job.job_sub_category_id" :list="job_sub_category_filtered_list" :label="locale.jobSubCategory"/>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-50">
									<form-select v-model="job.job_type_id" :list="job_type_list" :label="locale.jobType"/>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-50">
									<form-select v-model="job.job_skill_id" :list="job_skill_list" :label="locale.jobSkill"/>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-50">
									<form-select v-model="job.job_qualification_id" :list="job_qualification_list" :label="locale.jobQualification"/>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-50">
									<form-select v-model="job.job_salary_id" :list="job_salary_list" :label="locale.jobSalary"/>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-50">
									<form-select v-model="job.location_province_id" :list="province_list" :label="locale.jobLocation"/>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-50">
									<form-datetime v-model="job.deadline_date" :label="locale.jobDeadline" />
								</div>
							
								<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
									<Editor style="height: 500px;width: 100%;border-radius: 5px;"
										v-model="job.content"
										api-key="ldywwz30g9zhdo7kgwt8jjimrbc7ypqozvkd0ur7vs8eg7uk"
										:init="editorConfig"/>
								</div>
								
							</div>
						</div>
						<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-30">
							<div class="md-layout">
								<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
									<h5>{{translate(locale.jobAttachment)}}</h5>
									<input type="file" ref="attachment" accept="" @change="handleAttachmentFile($event)" style="display: none"/>
								</div>
								<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100" v-for="attachment in job.attachment">
									<div  class="attachment-preview">
										<div style="width: 100%">
											<a :href="config.cdn + 'attachments/' + attachment.file_hash" target="_blank">{{attachment.name}}</a>
										</div>
										<i style="color: #f44336 !important; text-align: center; cursor: pointer;" class="material-icons" @click="remove(attachment.file_hash)">delete</i>
										
									</div>
								</div>

								<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100" v-if="job.attachment.length < 10">
									<div  class="attachment-upload" style="cursor:pointer" @click="$refs.attachment.click()">
										<loading v-if="attachment_uploading"/>
										<div v-else style="display: flex; justify-content: center; justify-items: center;">
											<i style="color: #999; text-align: center;" class="material-icons">attachment</i>
											<span style="color: #999; text-align: center;margin-left: 5px">{{translate(locale.upload)}}</span>
										</div>
									</div>
								</div>
							</div>	
						</div>
						<div class="md-layout-item md-size-100 text-right">
							<span v-for="e in errors" style="color: red">* {{translate(e)}}<br></span>
						</div>
						<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100 text-right">
							<md-button class="md-raised md-primary" @click="updateJob()">{{translate(locale.updateJob)}}</md-button>
						</div>
					</div>
					
				</md-card-content>
			</md-card>
		</div>
	</div>
		
	</div>

</template>

<script>
	import Editor from '@tinymce/tinymce-vue';
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime, Editor },
		created() {
			this.getSettings();
		},
		data() {
			return {
				loaded: false,
				uploading: false,
				attachment_uploading: false,
				job: {
					name: "",
					content: "",
					location_province_id: "",
					job_category_id: "",
					job_sub_category_id: "",
					job_type_id: "",
					job_skill_id: "",
					job_qualification_id: "",
					job_salary_id: "",
					deadline_date: "",
					deadline_timestamp: "",
					attachment: []
				},
				province_list: [],
				job_type_list: [],
				job_salary_list: [],
				job_qualification_list: [],
				job_skill_list: [],
				job_category_list: [],
				job_sub_category_list: [],
				job_sub_category_filtered_list: [],
				editorConfig: {
					height: 500,
					menubar: false,
					plugins: 'lists link image table code help wordcount',
					toolbar: 'undo redo | fontfamily fontsize | formatselect bold italic forecolor backcolor | image table | lineheight alignleft aligncenter alignright alignjustify | numlist bullist outdent indent | removeformat| link code | help',
					font_family_formats: 'Arial=arial,helvetica,sans-serif; Courier New=courier new,courier,monospace; Moul=Moul; Siemreap=Siemreap; Hanuman=Hanuman;',
					automatic_uploads: true,
					images_upload_handler: this.handleEditorFile,
				},
				errors: []
			}
		},
		watch: {
			'job.job_category_id' : function(val) {
				this.job_sub_category_filtered_list = [];
				this.job.job_sub_category = "";
				this.job.job_sub_category_id = "";
				for(let i = 0; i< this.job_sub_category_list.length; i++) {
					if(this.job_sub_category_list[i].job_category_id == val) this.job_sub_category_filtered_list.push(this.job_sub_category_list[i]);
				}
			}
		},
		methods: {
			getSettings() {
				this.$http.get(this.config.api + "/profile/setting/job").then(data => {

					this.province_list = this.config.clearList(data.body.data.province, this.$store.state.l.lang);
					this.job_category_list = this.config.clearList(data.body.data.job_category, this.$store.state.l.lang);
					this.job_sub_category_list = this.config.clearList(data.body.data.job_sub_category, this.$store.state.l.lang);
					this.job_skill_list = this.config.clearList(data.body.data.job_skill, this.$store.state.l.lang);
					this.job_qualification_list = this.config.clearList(data.body.data.job_qualification, this.$store.state.l.lang);
					this.job_salary_list = this.config.clearList(data.body.data.job_salary, this.$store.state.l.lang);
					this.job_type_list = this.config.clearList(data.body.data.job_type, this.$store.state.l.lang);

					this.$http.get(this.config.api + "/profile/job/get/" + this.$route.params.hash).then(data => {

						let job = data.body.data.job;
						let attachment = data.body.data.attachment;

						this.job.name = job.name;
						this.job.content = job.content;
						this.job.job_category_id = job.job_category_id;
						this.job.location_province_id = job.location_province_id; 
						this.job.job_type_id = job.job_type_id;
						this.job.job_skill_id = job.job_skill_id;
						this.job.job_qualification_id = job.job_qualification_id;
						this.job.job_salary_id = job.job_salary_id;

						this.job.deadline_date = (new Date(job.deadline_date * 1000)).toISOString();

						for(let i =0; i< attachment.length; i++) {
							this.job.attachment.push({name: attachment[i].name, file_hash: attachment[i].url});
						}
						this.loaded = true;

						setTimeout(() => {
							this.job.job_sub_category_id = job.job_sub_category_id;
						}, 200);

					})
				})
			},
			updateJob(draft = false) {

				if(draft) this.job.status = 2;
				else this.job.status = 1;

				this.job.deadline_timestamp = (new Date(this.job.deadline_date)).getTime();

				if(!this.checkValidation()) {
					this.$notification.notify({message: "Please fill in all required information.||សូមបំពេញព័ត៌មានឱ្យបានគ្រប់គ្រាន់។", icon: 'error', type: 'danger'});
					return;
				}
				
				this.$http.post(this.config.api + "/profile/job/update", {
					hash: this.$route.params.hash,
					job: this.job
				}).then(res => {
					if(res.body.status == 'success') {
						this.$notification.notify({
							message: "You have updated job successfully.||អ្នកបានធ្វើការកែប្រែការជ្រើសរើសបុគ្គលិកបានដោយជោគជ័យ។",
							icon: 'check_circle',
							type: 'success'
						});

						this.$router.push("/job_recruitment");
					}
				})
			},

			handleEditorFile(blobInfo, success, failure) {

				const formData = new FormData();
				formData.append('file', blobInfo.blob(), blobInfo.filename());

				this.$http.post(this.config.api + "/profile/upload/image_content", formData).then(res => {
					if (res.body.status == 'success') {
						success(this.config.cdn + res.body.data.image_hash);
					} else {
						failure("Error uploading image.");
					}
				})
			},
			handleAttachmentFile(event) {
				if (!event.target.files.length) return;

				const formData = new FormData();
				formData.append('file', this.$refs.attachment.files[0]);
				this.attachment_uploading = true;
				this.$http.post(this.config.api + "/profile/upload/attachment", formData).then(res => {
					this.attachment_uploading = false;
					if (res.body.status == 'success') {
						this.job.attachment.push(res.body.data);
					}
				})
			},
			checkValidation() {
				this.errors = [];

				if(String(this.job.name).length < 3) this.errors.push("Title is empty.");
				if(String(this.job.content).length < 3) this.errors.push("Content is empty.");
				if(String(this.job.job_category).length <= 0) this.errors.push("Job Category is empty.");
				if(String(this.job.job_sub_category_id).length <= 0) this.errors.push("Job Sub-Category is empty.");
				if(String(this.job.job_type_id).length <= 0) this.errors.push("Job Type is empty.");
				if(String(this.job.job_skill_id).length <= 0) this.errors.push("Job Skill Level is empty.");
				if(String(this.job.job_qualification_id).length <= 0) this.errors.push("Job Qualification is empty.");
				if(String(this.job.job_salary_id).length <= 0) this.errors.push("Job Salary is empty.");
				if(String(this.job.location_province_id).length <= 0) this.errors.push("Job Location is empty.");
				if(String(this.job.deadline_date).length <= 0 || parseInt(this.job.deadline_timestamp) == NaN) this.errors.push("Job Deadline is invalid.");

				if(this.errors.length == 0) return true;
				else return false;
			},
			remove(hash){
				const index = this.job.attachment.findIndex((obj) => obj.file_hash == hash);
				if (index > -1) this.job.attachment.splice(index, 1);
			},
		}
	}
</script>
<style scoped>
	.cover-image {
		border: 1px dashed #ccc; 
		min-height: 120px;
		/* margin-bottom: 8px;  */
		padding: 20px; 
		border-radius: 3px; 
		display: flex; 
		justify-content: center; 
		align-items: center; 
		cursor:pointer
	}
	.gallery-image {
		border: 1px dashed #ccc; 
		min-height: 120px; 
		margin-bottom: 8px;
		padding: 20px; 
		border-radius: 3px; 
		display: flex; 
		justify-content: center; 
		align-items: center
	}
	.attachment-preview {
		border: 1px dashed #ccc; 
		margin-bottom: 8px; 
		padding: 10px; 
		border-radius: 3px; 
		display: flex; 
		justify-content: left; 
		align-items: center
	}
	.attachment-upload {
		border: 1px dashed #ccc; 
		margin-bottom: 8px; 
		padding: 8px; 
		border-radius: 3px; 
		display: flex; 
		justify-content: center; 
		align-items: center
	}
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>


// WEBPACK FOOTER //
// src/pages/Job/Edit.vue